import { cloneElement } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface Props {
    label?: any;
    children: any;
    labelCentered?: boolean;
    header?:
        | {
              icon?: any;
              label: string;
          }
        | undefined;
    backgroundColor?: string;
    p?: string | number;
    width?: any;
    hoverable?: boolean;
    blackBorder?: boolean;
    sx?: any;
    dataCy?: string;
    id?: string;
    rowGap?: number;
}

const BorderBlockWithLabel = ({
    children,
    label,
    header,
    backgroundColor = 'white',
    p = 1,
    hoverable = false,
    blackBorder = false,
    width = 'auto',
    sx = {},
    dataCy = 'root',
    id = 'id',
    rowGap = 2,
}: Props) => (
    <Box
        width={width}
        sx={{
            border: `${blackBorder ? '3px black' : '1px rgb(9,23,71,0.1)'} solid `,
            borderRadius: 2,
            color: 'black',
            p,
            gap: 1,
            rowGap,
            display: 'grid',
            backgroundColor,
            ...(hoverable ? { ':hover': { boxShadow: 3 } } : {}),
            ...sx,
        }}
        data-cy={dataCy}
        id={id}
    >
        {header && (
            <Box
                sx={{
                    p: 1,
                    color: 'rgb(9,23,71,0.8)',
                    display: 'grid',
                    gridTemplateColumns: header.icon ? `35px auto` : 'auto',
                    alignItems: 'center',
                }}
                data-cy='header'
            >
                {header.icon && cloneElement(header.icon, { 'data-cy': 'headerIcon' })}

                <Typography sx={{ textTransform: 'uppercase', fontSize: 14 }} data-cy='headerLabel'>
                    <b>{header.label}</b>
                </Typography>
            </Box>
        )}

        {label && (
            <Typography sx={{ fontSize: 14 }} data-cy='label'>
                <b>{label}</b>
            </Typography>
        )}

        {children}
    </Box>
);

export default BorderBlockWithLabel;
